import { RootState } from "../../../../store";
import { commitmentsSliceSelector } from "../../commitmentsSliceSelector";

export const utilizationAndCoverageDatesSelector = (state: RootState) => {
  const slice = commitmentsSliceSelector(state);

  return slice.coverageAndUtilization.dates;
};
